import { sentryClient } from 'shared/sentry/client';

/**
 * Track an error
 * @param {Error|Object} error
 */
export default function trackError(error) {
  if (process.env.NODE_ENV === 'production') {
    if (window.Sentry) {
      sentryClient.captureException(error);
    }
  } else {
    console.error('ERROR', error); // eslint-disable-line no-console
  }
}
